import * as PouchDBModule from "pouchdb-browser";
export const PouchDB = (PouchDBModule as any).default;
